import React from 'react';
import DashboardEventsByNameChart from '../charts/DashboardEventsByNameChart';
import { useDashboardStatisticsAccess } from '../useDashboardStatisticsAccess';

export default function EventsByNameCard({
  player,
  handleId,
  loading: profileLoading,
  statisticsAccessResourceKey = null,
}) {
  const hid = Number(handleId);
  const hidOk = Number.isInteger(hid) && hid >= 1;
  const { canViewStatistics } = useDashboardStatisticsAccess(player, {
    extraReadResourceKey: statisticsAccessResourceKey,
  });

  if (!hidOk) return null;

  if (profileLoading && !player) {
    return (
      <section
        className="member-dashboard__panel-card member-dashboard__events-card"
        aria-busy="true"
        aria-label="Events by name statistics"
        data-resource="private.navbar.personalhub.events"
        data-action="read"
        data-description="Personal hub — events by name statistics"
      >
        <div className="member-dashboard__panel-card-head">
          <h2 className="member-dashboard__panel-title">Events by name</h2>
        </div>
        <div className="member-dashboard__panel-card-body">
          <p className="member-dashboard__panel-placeholder">Loading…</p>
        </div>
      </section>
    );
  }

  if (!canViewStatistics) {
    return (
      <section
        className="member-dashboard__panel-card member-dashboard__events-card"
        aria-label="Events by name statistics"
        data-resource="private.navbar.personalhub.events"
        data-action="read"
        data-description="Personal hub — events by name statistics"
      >
        <div className="member-dashboard__panel-card-head">
          <h2 className="member-dashboard__panel-title">Events by name</h2>
        </div>
        <div className="member-dashboard__panel-card-body">
          <p className="member-dashboard__panel-placeholder">
            You do not have permission to view event statistics for this member.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section
      className="member-dashboard__panel-card member-dashboard__events-card"
      aria-label="Events by name statistics"
      data-resource="private.navbar.personalhub.events"
      data-action="read"
      data-description="Personal hub — events by name statistics"
    >
      <DashboardEventsByNameChart
        title="Events by name"
        handleId={player?.handleId ?? handleId}
        scope="cluster"
        enabled={canViewStatistics}
      />
    </section>
  );
}
